import moment from 'moment'
import { NumberFormat } from 'utils/format'
import styles from './GiftingSummaryHeader.module.scss'
import {
  activationDateValue,
  amountValue,
  beneficiaryNameValue,
  firstDayValue,
  frequencyValue,
  secondDayValue
} from 'modules/contribution/LocalState'
import { Frequency } from 'modules/contribution/types'
import { getFrequencyLabel } from 'utils/helpers'
import { ProfilePic } from '@collegebacker/backer-ui/ui'
import classNames from 'classnames'
import { getOrdinalNumber } from 'utils'

export const GiftingSummaryHeader = ({
  fund
}: {
  fund?: {
    fundName: string
    giftingPage: {
      photoUrl: string
    }
  }
}) => {
  const {
    fundName,
    giftingPage: { photoUrl }
  } = fund || { giftingPage: {} }
  const amount = amountValue()
  const frequency = frequencyValue()
  const activationDate = activationDateValue()
  const firstDay = firstDayValue()
  const secondDay = secondDayValue()
  const beneficiaryName = beneficiaryNameValue()

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.title}>Gift summary</p>
      </div>

      <div className={styles.body}>
        <div className={styles.content}>
          <p className={classNames('typo-app-title-small', styles.title)}>
            {NumberFormat.currencyFromCents(amount, false, true)}{' '}
            {getFrequencyLabel(frequency)}
          </p>
          <p className={styles.text}>
            Payment to {fundName || beneficiaryName}
          </p>
          <p className={styles.dateLabel}>
            {getDateLabel({ frequency, activationDate, firstDay, secondDay })}
          </p>
        </div>
        <ProfilePic
          imageSrc={photoUrl}
          name={fundName || beneficiaryName}
          className={styles.photo}
        />
      </div>
    </div>
  )
}

const getDateLabel = ({
  frequency,
  activationDate,
  firstDay,
  secondDay
}: {
  frequency: Frequency
  activationDate: Date
  firstDay: number
  secondDay: number
}) => {
  const date = moment(activationDate)
  if (frequency === 'semimonthly') {
    return `on the ${getOrdinalNumber(firstDay)} and ${getOrdinalNumber(
      secondDay
    )} of each month`
  }
  if (frequency === 'monthly') {
    return `on the ${getOrdinalNumber(firstDay)} of each month`
  }
  return `on ${date.format('MMM D, YYYY')}`
}
